import { Component, OnInit } from '@angular/core';
import { Input, OnDestroy } from '@angular/core';
import { NavigationEnd, ActivatedRoute, Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Feed } from '@purplefront/catalog/data-access';

const defaultPages = [
  { type: 'all', slug: 'all', label: 'All' },
  { type: 'news', slug: 'news', label: 'News' },
  { type: 'agenda', slug: 'agenda', label: 'Agenda' },
  { type: 'search', slug: 'search', label: 'Search' }
];

@Component({
  selector: 'app-bookmarks-menu',
  templateUrl: './bookmarks-menu.component.html',
  styleUrls: ['./bookmarks-menu.component.scss']
})
export class BookmarksMenuComponent implements OnInit, OnDestroy {
  @Input() bookmarkCount: number;

  public catalog: string | null;
  public feeds$: Observable<Feed[]>;
  public currentFeed: Feed[];
  private activeRouteSubscription: Subscription;
  public currentPageType: string;
  public lang: string;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    /**
     * Get current route datas
     */

    this.activeRouteSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((route) => {
          this.getActiveRoute();
        })
      )
      .subscribe();

    this.getActiveRoute();
  }

  public getActiveRoute() {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    for (const key in defaultPages) {
      if (defaultPages.hasOwnProperty(key)) {
        if (defaultPages[key].type === route.snapshot.url[0].path) {
          this.currentPageType = defaultPages[key].type;
          this.lang = route.snapshot.params.lang;
          break;
        } else {
          this.currentPageType = 'all';
        }
      }
    }
  }

  /**
   * Prevent memory leaks
   */

  ngOnDestroy() {
    this.activeRouteSubscription.unsubscribe();
  }
}
